import React, { useEffect, useState } from 'react'
import { Nav, Tab, Card } from 'react-bootstrap'
import { getDataList } from '../../api/common'
import { ActividadesTotal } from './ActividadesTotal'
import { ActividadesAbiertas } from '../../pages/actividades/ActividadesAbiertas'
import moment from 'moment'

export const ConsulActividades = () => {
    const [actividades, setActividades]=useState()
    const [refresh, setRefresh]=useState(false);
    const [tabActiva, setTabActiva] = useState('abiertas');

    useEffect( ()=>{  
        async function  consultarActividades(){
            const resultado=await getDataList('Actividad')
            console.log('Resultado consulta: ',resultado);
            setActividades(resultado.data.data)
        }
        consultarActividades()
    },[refresh])
    
  return (
    <div className="container-fluid">
      <Card className="w-100">
        <Card.Header className='w-100'>
          <h4 className="mb-0">
            <i className="bi bi-calendar-check me-2"></i>
            Gestión de Actividades
          </h4>
        </Card.Header>
        <Card.Body className="p-0 w-100">
          <Tab.Container activeKey={tabActiva} onSelect={(k) => setTabActiva(k)}>
            <Nav variant="tabs" className="px-3 pt-3">
              <Nav.Item>
                <Nav.Link eventKey="abiertas">
                  <i className="bi bi-list-ul me-2"></i>
                  Actividades Abiertas
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="cronograma">
                  <i className="bi bi-calendar3 me-2"></i>
                  Cronograma
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="p-3">
              <Tab.Pane eventKey="abiertas">
                <ActividadesAbiertas refresh={refresh} setRefresh={setRefresh} />
              </Tab.Pane>
              
              <Tab.Pane eventKey="cronograma">
                <ActividadesTotal refresh={refresh} setRefresh={setRefresh} actividades={actividades} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Card.Body>
      </Card>
    </div>
  )
}

